import { styled } from "@tamagui/core";
import { YStack } from "../../Layout/Stacks.mjs";
import { StyleableInternalText } from "../../Typography/Typography.Text";
import { jsxs } from "react/jsx-runtime";
const Label = styled(StyleableInternalText, {
    name: "FieldLabel",
    size: "small",
    tag: "label",
    variant: "secondary",
    variants: {
      state: {
        error: {
          variant: "error"
        }
      }
    }
  }),
  Hint = styled(StyleableInternalText, {
    name: "FieldHint",
    size: "tiny",
    variant: "discreet",
    variants: {
      state: {
        error: {
          variant: "error"
        }
      }
    }
  }),
  Field = ({
    children,
    hint,
    label
  }) => /* @__PURE__ */jsxs(YStack, {
    gap: "$field.spacing",
    children: [label || null, children, hint || null]
  });
Field.Label = Label;
Field.Hint = Hint;
export { Field };
//# sourceMappingURL=Field.mjs.map
